import '../../sass/blocks/quotes-carousel.scss';

const noMotionPreference = window.matchMedia('(prefers-reduced-motion: no-preference)');

(() => {
    const $quotesCarousels = document.querySelectorAll('.quotes-carousel');

    if (!$quotesCarousels) return;

    $quotesCarousels.forEach($quotesCarousel => {
        const $carousel = $quotesCarousel.querySelector('.quotes-carousel__carousel');
        const $carouselSlides = $quotesCarousel.querySelectorAll('.swiper-slide');

        const initCarousel = () => {
            if (!$carousel || $carouselSlides?.length <= 1) return;

            new Swiper($carousel, {
                keyboard: {
                    enabled: true,
                    onlyInViewport: true
                },
                loop: true,
                speed: noMotionPreference.matches ? 300 : 0,
            });
        };

        initCarousel();
    });
})();
